import { W as WuiDateRangeInput$1, d as defineCustomElement$1 } from './p-CMW6llix.js';

const WuiDateRangeInput = WuiDateRangeInput$1;
const defineCustomElement = defineCustomElement$1;

export { WuiDateRangeInput, defineCustomElement };
